import { StoryBible } from "../core/types";
import { getStrings } from "../core/i18n";

function sanitizeFileName(name: string): string {
  return name.replace(/[\\/:*?"<>|]/g, "_").trim() || "story-bible";
}

// Mirrors exportChat.ts's buildExportMarkdown/exportSessionToFile exactly — same manual,
// permanent-backup rationale, same plain-Markdown-with-literal-headers shape so it's legible both
// to a human and, if pasted elsewhere, to another AI. Each entry's own include/exclude state
// (StoryBibleEntry.included) is noted per entry rather than left ambiguous — the exported file is
// meant to be a full, honest snapshot of the bible as saved, not just what currently gets sent.
export function buildStoryBibleExportMarkdown(bible: StoryBible): string {
  const s = getStrings();
  const lines: string[] = [
    `# ${bible.name}`,
    "",
    `${s.exportFile.exported} ${new Date().toLocaleString()}`,
    "",
    "---",
    "",
  ];
  for (const entry of bible.entries) {
    const heading = entry.title || s.exportFile.untitledEntry;
    lines.push(`## ${heading}${entry.included ? "" : s.exportFile.excludedFromContext}`);
    lines.push("");
    lines.push(entry.text);
    lines.push("");
  }
  return lines.join("\n");
}

export function exportStoryBibleToFile(bible: StoryBible): void {
  const text = buildStoryBibleExportMarkdown(bible);
  const blob = new Blob([text], { type: "text/markdown;charset=utf-8" });
  const fileName = `${sanitizeFileName(bible.name)}.md`;

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
